import { render, staticRenderFns } from "./TourCreateView.vue?vue&type=template&id=1b28c273&scoped=true"
import script from "./TourCreateView.vue?vue&type=script&lang=js"
export * from "./TourCreateView.vue?vue&type=script&lang=js"
import style0 from "./TourCreateView.vue?vue&type=style&index=0&id=1b28c273&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b28c273",
  null
  
)

export default component.exports